// extracted by mini-css-extract-plugin
export default {"wrap":"ur-z","searchHeaderWrap":"vr-z","melodyCategory":"wr-z","fullWidth":"xr-z","items":"yr-z","featureCss":"zr-z","disabled":"Ar-z","imgCss":"Br-z"};